module.exports = __webpack_public_path__ + "media/images/pernambucanas-3a4d6128e9bc68f3f6abd082c33d3eef.png";